import Axios from "axios";
import {
  SET_PRODUCTION_SEWING_LINE_LIST,
  UNSET_PRODUCTION_SEWING_LINE_LIST,
  SET_PRODUCTION_SEWING_INPUT_LIST,
  UNSET_PRODUCTION_SEWING_INPUT_LIST,
  SET_PRODUCTION_SEWING_OUTPUT_LIST,
  UNSET_PRODUCTION_SEWING_OUTPUT_LIST,
} from "@/store/mutation-types";
import { 
  sewingLineResource, 
  sewingInputResource, 
  sewingOutputResource 
} from "@/store/api";

// Initial State
const state = {
  getProductionSewingLineList: [],
  getProductionSewingInputList: [],
  getProductionSewingOutputList: [],
};

// Getters
const getters = {
  getProductionSewingLineList(state) {
    return state.getProductionSewingLineList;
  },
  getProductionSewingInputList(state) {
    return state.getProductionSewingInputList;
  },
  getProductionSewingOutputList(state) {
    return state.getProductionSewingOutputList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_SEWING_LINE_LIST](state, data) {
    state.getProductionSewingLineList = data;
  },
  [UNSET_PRODUCTION_SEWING_LINE_LIST](state) {
    state.getProductionSewingLineList = [];
  },
  [SET_PRODUCTION_SEWING_INPUT_LIST](state, data) {
    state.getProductionSewingInputList = data;
  },
  [UNSET_PRODUCTION_SEWING_INPUT_LIST](state) {
    state.getProductionSewingInputList = [];
  },
  [SET_PRODUCTION_SEWING_OUTPUT_LIST](state, data) {
    state.getProductionSewingOutputList = data;
  },
  [UNSET_PRODUCTION_SEWING_OUTPUT_LIST](state) {
    state.getProductionSewingOutputList = [];
  },
};

// Actions
const actions = {

  getProductionSewingInputList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(sewingInputResource)
        .then((response) => {
          commit(SET_PRODUCTION_SEWING_INPUT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_SEWING_INPUT_LIST);
          reject(error);
        });
    });
  },

  getProductionSewingOutputList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(sewingOutputResource)
        .then((response) => {
          commit(SET_PRODUCTION_SEWING_OUTPUT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(SET_PRODUCTION_SEWING_OUTPUT_LIST);
          reject(error);
        });
    });
  },

  // SEWING LINES
  getProductionSewingLineList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(sewingLineResource)
        .then((response) => {
          commit(SET_PRODUCTION_SEWING_LINE_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_SEWING_LINE_LIST);
          reject(error);
        });
    });
  },

  saveProductionSewingLine({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(sewingLineResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  updateProductionSewingLine({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    const url = `${sewingLineResource}/${id}`;
    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
  // SEWING INPUT
  saveSewingInput({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(sewingInputResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // SEWING OUTPUT
  saveSewingOutput({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(sewingOutputResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSewingInputById({ commit }, { id }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${sewingInputResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.get(url)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },


  updateSewingInput({ commit }, { id, data }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${sewingInputResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.put(url, data)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

  updateSewingOutput({ commit }, { id, data }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${sewingOutputResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.put(url, data)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

    getSewingOutputById({ commit }, { id }) {
      commit("SET_LOADING", { color: "primary" });

      const url = `${sewingOutputResource}/${id}`;

      return new Promise((resolve, reject) => {
      Axios.get(url)
          .then((response) => {
          resolve(response);
          })
          .catch((error) => {
          reject(error);
          })
          .finally(() => {
          commit("UNSET_LOADING");
          });
      });
  },

  getProductionSewingOutputsByLine({ commit }, lineId) {
    return new Promise((resolve, reject) => {
      const url = `${sewingLineResource}/${lineId}/outputs`;
      Axios.get(url)
        .then((response) => {
          commit(SET_PRODUCTION_SEWING_OUTPUT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_SEWING_OUTPUT_LIST);
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};

